import Link from "./link";

function App() {
  return (
    <>
    <Link/>
    </>
  );
}

export default App;
